module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "bgclr"
  }, [_c('div', {
    staticClass: "image_wrap_small"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('img', {
    staticClass: "image2",
    attrs: {
      "alt": "image",
      "src": "images/f03-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "running_first1"
  }, [_vm._v("WHAT CAN YOU SAY"), _c('br'), _vm._v("ABOUT LOVE THAT"), _c('br'), _vm._v("HASN’T ALREADY BEEN"), _c('br'), _vm._v("SAID A MILLION TIMES"), _c('br'), _vm._v("BEFORE, AND BETTER?")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('span', {
    staticClass: "white"
  }, [_vm._v("Truthfully? Nothing. For as long as we’ve had words, human beings have been trying to use them to express something that we all know deep-down is far too big—too vast, powerful, and wonderful—too confusing, complicated, and simple—for us to ever really articulate properly. And yet we kept trying and trying. Which means that, by now, at this late stage in the game, the odds of coming up with anything new and original to say about love are as slim as odds can get.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "white"
  }, [_vm._v("Then again. What were the odds of you meeting and falling in love with the person you find yourself—somehow, mysteriously, magically—together with today? How many twists and turns of fate or chance or luck or screw-up had to happen to land you in each other’s arms? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A lot")]), _vm._v(", that’s how many. If something as statistically unlikely as the meeting, connecting, and ultimate coupling of person A and person B out of all the billions of people in the world can happen, then, who knows? Maybe we can find something new to say about love, too. Stranger things have happened. Maybe it’s just a question of finding a medium, a material other than words, to carry the meaning.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "white"
  }, [_vm._v("And that’s where our pals, the visual artists, come in. The old adage would have us believe that a picture is worth a thousand words, but perhaps more to the point is that a picture can sometimes capture what even "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("a thousand words cannot. The subtleties of the body (that slight tilt of the head toward the object of affection, that tiny half smile just because two people are in the same room together); the emblems of attachment (how flowers and chocolates and lacy hearts and rings really can, in our unguarded moments, mean so much to us); the myriad emotional waves we ride (humor, flirtation, wisdom, sensuality, hope, despair, excitement, repose)—all of this and so much more can be captured in an image.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "white"
  }, [_vm._v("And the artists in this book have done that for us. They are, ever so graciously, ever so lovingly, giving us a visual language. A set of illuminations to hold up—like travelers in a foreign land where we don’t speak the language—and point to while we look at our sweeties with yearning eyes that say "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" and especially "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" is just exactly how I feel about you.")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt"
  }, [_c('span', {
    staticClass: "white"
  }, [_vm._v("For all the things we want to say but don’t, for all the things we know in our hearts but can’t express with words, we turn to the images in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Art of I Love You")]), _vm._v(". And they reflect and magnify our love, dozens of times over, beautifully."), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a6ed564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_ch01.vue
// module id = 69
// module chunks = 0